import type { OrderedStep } from "@instacover/helpers"
import type {
  InstacarAppLanguage as InstacarAppLanguageDb,
  PhotoType as PhotoTypeDb,
  VehicleType as VehicleTypeDb,
} from "@instacover/instacar-database/browser"
import { isNil } from "@instacover/utils"
import { inferRouterInputs, inferRouterOutputs } from "@trpc/server"

import type { MainRouter } from "../../../backend/src/routers/trpc/trpcRouter"
import { logger } from "./monitoring/logging"

export type RouterInput = inferRouterInputs<MainRouter>
export type RouterOutput = inferRouterOutputs<MainRouter>

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type FunctionAny = (...args: any[]) => any

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
export type Tail<T extends any[]> = T extends [infer A, ...infer R] ? R : never

export type DeepPartial<T> = {
  [P in keyof T]?: DeepPartial<T[P]>
}

export type PhotoType = PhotoTypeDb
export type VehicleType = VehicleTypeDb
export type InstacarAppLanguage = InstacarAppLanguageDb
export type StepType = OrderedStep["stepType"]
export type SessionDetail = RouterOutput["app"]["getSessionDetail"]
export type SessionConfig = RouterOutput["app"]["getSessionConfig"]
export type SessionPhoto = RouterOutput["app"]["getPhotos"][number]
export type SessionVideo = RouterOutput["app"]["getVideos"][number]
export type SessionClaimMarkerData = RouterOutput["app"]["getClaimData"][number]

export type StepPhoto = RouterOutput["app"]["getPhotos"][number]

export type UserModelMatch = RouterInput["app"]["upsertPhoto"]["userModelMatch"]
export type PhotoLocation = RouterInput["app"]["upsertPhoto"]["location"]
export type MarkerInput = NonNullable<RouterInput["app"]["upsertPhoto"]["markers"]>[number]
export type FrontendLogType = RouterInput["app"]["log"]["type"]

export function stringifyError(error: unknown) {
  if (isNil(error)) {
    logger.info("stringifyError: error is nil", error)
    return
  }

  try {
    return JSON.stringify(error, Object.getOwnPropertyNames(error))
  } catch (error_) {
    logger.error("Failed to stringify error", error_)
  }

  try {
    return JSON.stringify(error)
  } catch (error_) {
    logger.error("Failed to stringify error", error_)
  }

  return JSON.stringify({ error: "failed to stringify" })
}
